<template>
  <component :is="as" :class="classes">
    <slot />
  </component>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';

export const variants = ['default', 'solid-dark'];

export default {
  name: 'ELabel',
  mixins: [classes],
  props: {
    as: {
      type: String,
      default: 'span',
    },
    variant: {
      type: String,
      validator: (variant) => variants.includes(variant),
      default: variants[0],
      cssClass: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$height: $space-l;

.label {
  display: inline-flex;
  align-items: center;
  height: $height;
  font-size: $font-1s;
  padding-left: $space-s;
  padding-right: $space-s;
  border-radius: $border-radius-full;
  color: $color-text-tertiary;
  background-color: $color-brand-primary;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.label--variant-solid-dark {
  background: $gray-60;
}
</style>

<docs>
```js
<ELabel>Beta</ELabel>
```
</docs>
